export default __webpack_public_path__ + "static/media/zoom_out.13ef3ab8.svg";